import React, {ReactElement, useContext} from 'react';

import invariant from 'invariant';

import getBalancesForTable from '../rendering/getBalancesForTable';

import FixtureContext, {FixtureContextValue} from './FixtureContext';
import Table from './Table';

export default function Balances(): ReactElement {
  const fixtureContext = useContext<FixtureContextValue>(FixtureContext);
  invariant(
    fixtureContext.status === 'loaded' || fixtureContext.status === 'updating',
    'Must already be loaded or updating',
  );
  const {currentFixture} = fixtureContext;

  const {rows, tableConfig} = getBalancesForTable(currentFixture.fixtureFile);

  return <Table rows={rows} tableConfig={tableConfig} />;
}
